import React from "react";

/**
 * Indian numbers come in as "9790778486", "919790778486", "+91 97907 78486" or "09790778486".
 * Returns the readable form ("+91 97907 78486") and the dialable form ("+919790778486"). Anything
 * that is not a recognisable Indian mobile is shown as typed and dialled with its digits.
 */
export function formatIndianPhone(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return { display: "", dial: "" };
  let digits = raw.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  if (digits.length === 10) digits = `91${digits}`;
  if (digits.length === 12 && digits.startsWith("91")) {
    const local = digits.slice(2);
    return { display: `+91 ${local.slice(0, 5)} ${local.slice(5)}`, dial: `+${digits}` };
  }
  return { display: raw, dial: digits ? `${raw.startsWith("+") ? "+" : ""}${digits}` : "" };
}

/** A phone number in readable form with a call icon that dials it on a phone. */
export default function PhoneLink({ phone, label, className = "small text-muted", empty = "-" }) {
  const { display, dial } = formatIndianPhone(phone);
  if (!display) return empty == null ? null : <div className={className}>{empty}</div>;
  return (
    <div className={`d-flex align-items-center gap-1 text-nowrap ${className}`}>
      {label ? <span>{label}:</span> : null}
      <span>{display}</span>
      {dial ? (
        <a
          href={`tel:${dial}`}
          className="text-success text-decoration-none ms-1"
          title={`Call ${display}`}
          aria-label={`Call ${label ? `${label} ` : ""}${display}`}
        >
          <i className="bi bi-telephone-fill" />
        </a>
      ) : null}
    </div>
  );
}
